<template>
  <div class="form-field form-field-boolean">
    <label :for="field.name">{{ label }}</label>
    <ul>
      <li v-for="option in options" :key="option.name">
        <FormFieldButtonSelect
          :name="option.name"
          :value="option.name"
          :selected="fieldValue === option.value"
          direction="row"
          theme="primary"
          aspect="16-9"
          @select="() => handleSelect(option)"
        />
      </li>
    </ul>
    <span
      v-for="(message, index) in feedback"
      :key="index"
      class="form-field-error"
    >
      {{ message }}
    </span>
  </div>
</template>
<script setup lang="ts">
interface Props {
  field: FormField;
}

const props = defineProps({
  field: null
});

const {
  formFieldsData: { memberValues },
  checkValidatedFormOnMounted,
} = inject(INJECT_FORM_PAGE);

const blured = ref<boolean>(false);

const fieldValue = computed({
  get() {
    return memberValues.value[props.field.name].value;
  },
  set(value) {
    memberValues.value[props.field.name].value = value;
  },
});

const label = computed(() => {
  return isFieldRequired(props.field)
    ? `${props.field.label}*`
    : props.field.label;
});

const options = [
  { name: 'non', value: false },
  { name: 'oui', value: true },
];

const { messages } = useFormFieldValidation(props.field, memberValues);

const feedback = computed(() => {
  let feedbackMessages = [''];
  if (blured.value && messages.value.length > 0) {
    feedbackMessages = [...messages.value];
  }
  return feedbackMessages;
});

const handleSelect = (option) => {
  fieldValue.value = option.value;
};

const { available: availableDialog, open: openDialog } =
  useDialogFormBooleanConfig(props.field?.config?.popinRGPD, fieldValue);

watch(
  () => fieldValue.value,
  (to) => {
    if (to === false && availableDialog.value) {
      openDialog();
    }
  }
);

onMounted(() => {
  if (checkValidatedFormOnMounted.value) blured.value = true;
});
</script>
<style lang="scss" scoped>
label {
  text-align: center;
}
ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gap_l);
}
</style>
